var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedoEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7487_14937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3326 6.66635V10.6664M19.3326 10.6664H15.3326M19.3326 10.6664L16.2459 7.75968C15.3263 6.83951 14.1326 6.24314 12.8446 6.06045C11.5566 5.87775 10.244 6.11863 9.10484 6.74678C7.96563 7.37493 7.06143 8.35632 6.52851 9.54306C5.99559 10.7298 5.86281 12.0576 6.15018 13.3264C6.43755 14.5952 7.12951 15.7362 8.12177 16.5775C9.11404 17.4188 10.3529 17.9148 11.6515 17.9907C12.9502 18.0667 14.2384 17.7185 15.322 16.9987C16.4056 16.2788 17.2259 15.2263 17.6593 13.9997",
    stroke: "#2b60f6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7487_14937"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedoEdit);
export default __webpack_public_path__ + "static/media/redoEdit.6143b07fac740c43e03f91e633a68e91.svg";
export { ForwardRef as ReactComponent };